import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

import Sidebar from '../components/Sidebar';
import Settings from './Settings';
import Proxy from './Proxy';
import AllowedUrls from './AllowedUrls';
import AddProfileModal from '../components/AddProfileModal';
import AddGroupModal from '../components/AddGroupModal';
import AddUserModal from '../components/AddUserModal';
import EditProfileModal from '../components/EditProfileModal';
import EditGroupModal from '../components/EditGroupModal';
import EditUserModal from '../components/EditUserModal';
import ConfirmModal from '../components/ConfirmModal';
import './Dashboard.css';

import TableFilter from '../components/TableFilter';
import TableSearch from '../components/TableSearch';


function ManagementView({ loading, profiles, grupos, usuarios, onAddProfile, onAddGroup, onAddUser, onToggleStatus, onEditProfile, onEditGroup, onEditUser, onDeleteProfile, onDeleteGroup }) {
  // Estado para busca por nome de perfil
  const [profileSearchTerm, setProfileSearchTerm] = useState('');
  // Paginação de perfis
  const [currentProfilePage, setCurrentProfilePage] = useState(1);
  const profilesPerPage = 10;
  // Estado para busca por nome de grupo
  const [groupSearchTerm, setGroupSearchTerm] = useState('');
  // Paginação de grupos
  const [currentGroupPage, setCurrentGroupPage] = useState(1);
  const groupsPerPage = 10;
  // Estado para busca por nome
  const [searchTerm, setSearchTerm] = useState('');
  // Filtro e paginação de grupos
  const [profileGroupFilter, setProfileGroupFilter] = useState('todos');
  // Filtro de perfis: por nome
  let filteredProfiles = profiles;
  if (profileSearchTerm.trim() !== '') {
    const profileTerm = profileSearchTerm.trim().toLowerCase();
    filteredProfiles = filteredProfiles.filter(p => (p["profile name"] || '').toLowerCase().includes(profileTerm));
  }
  // Paginação de perfis
  const totalProfilePages = Math.ceil(filteredProfiles.length / profilesPerPage);
  const paginatedProfiles = filteredProfiles.slice((currentProfilePage - 1) * profilesPerPage, currentProfilePage * profilesPerPage);
  // Opções para filtro de grupo
  const profileOptions = [
    { value: 'todos', label: 'Todos os Perfis' },
    ...profiles.map(p => ({ value: p.id, label: p["profile name"] }))
  ];
  // Filtro de grupos: por perfil e por nome
  let filteredGrupos = profileGroupFilter === 'todos'
    ? grupos
    : grupos.filter(g => String(g.profile_id) === String(profileGroupFilter));
  if (groupSearchTerm.trim() !== '') {
    const groupTerm = groupSearchTerm.trim().toLowerCase();
    filteredGrupos = filteredGrupos.filter(g => (g.nome_grupo || '').toLowerCase().includes(groupTerm));
  }
  // Paginação de grupos
  const totalGroupPages = Math.ceil(filteredGrupos.length / groupsPerPage);
  const paginatedGrupos = filteredGrupos.slice((currentGroupPage - 1) * groupsPerPage, currentGroupPage * groupsPerPage);
  // Filtro e paginação de usuários

  const [userStatusFilter, setUserStatusFilter] = useState('todos');
  const [groupFilter, setGroupFilter] = useState('todos');
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  // Opções para filtro de grupo
  const groupOptions = [
    { value: 'todos', label: 'Todos os Grupos' },
    ...grupos.map(g => ({ value: g.id, label: g.nome_grupo }))
  ];


  // Filtro encadeado: status, grupo e busca por nome
  let filteredUsers = usuarios;
  if (userStatusFilter !== 'todos') {
    filteredUsers = filteredUsers.filter(u => (u.status || 'inativo') === userStatusFilter);
  }
  if (groupFilter !== 'todos') {
    filteredUsers = filteredUsers.filter(u => String(u.grupo_id) === String(groupFilter));
  }
  if (searchTerm.trim() !== '') {
    const term = searchTerm.trim().toLowerCase();
    filteredUsers = filteredUsers.filter(u => (u.nome_completo || '').toLowerCase().includes(term));
  }
  // Ordena ativos primeiro
  filteredUsers = [...filteredUsers].sort((a, b) => {
    const statusA = (a.status || 'inativo') === 'ativo' ? 0 : 1;
    const statusB = (b.status || 'inativo') === 'ativo' ? 0 : 1;
    return statusA - statusB;
  });

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage);

  // TableFilter props
  const filterProps = [
    {
      label: 'Status',
      value: 'user-status-filter',
      selected: userStatusFilter,
      onChange: (val) => { setUserStatusFilter(val); setCurrentPage(1); },
      options: [
        { value: 'todos', label: 'Todos' },
        { value: 'ativo', label: 'Ativos' },
        { value: 'inativo', label: 'Inativos' }
      ]
    },
    {
      label: 'Grupo',
      value: 'user-group-filter',
      selected: groupFilter,
      onChange: (val) => { setGroupFilter(val); setCurrentPage(1); },
      options: groupOptions
    }
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div id="perfis" className="section-container">
        <div className="main-header user-header-flex">
          <div className="usuarios-title-group">
            <h2 className="usuarios-title">Perfis de Navegador</h2>
            <div className="user-filter-group">
              <TableSearch
                value={profileSearchTerm}
                onChange={val => { setProfileSearchTerm(val); setCurrentProfilePage(1); }}
                placeholder="Buscar por nome do perfil..."
              />
            </div>
          </div>
          <button onClick={onAddProfile} className="add-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            <span>Novo Perfil</span>
          </button>
        </div>
        <div className="content-area">
          {loading ? <p className="loading-text">Carregando...</p> : (
            <>
              <table>
                <thead><tr><th>Nome do Perfil</th><th>Ações</th></tr></thead>
                <tbody>
                  {paginatedProfiles.length > 0 ? paginatedProfiles.map(p => (
                    <tr key={p.id}>
                      <td data-label="Nome do Perfil">{p["profile name"]}</td>
                      <td data-label="Ações" className="actions-cell">
                        <button onClick={() => onEditProfile(p)} className="action-button edit">Editar</button>
                        <button onClick={() => onDeleteProfile(p)} className="action-button delete">Excluir</button>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="2" className="empty-table-message">Nenhum perfil cadastrado.</td></tr>
                  )}
                </tbody>
              </table>
              {/* Paginação de perfis */}
              {totalProfilePages > 1 && (
                <div className="pagination-container">
                  <button className="pagination-btn" onClick={() => setCurrentProfilePage(currentProfilePage - 1)} disabled={currentProfilePage === 1}>Anterior</button>
                  {Array.from({ length: totalProfilePages }, (_, i) => (
                    <button
                      key={i + 1}
                      className={`pagination-btn${currentProfilePage === i + 1 ? ' active' : ''}`}
                      onClick={() => setCurrentProfilePage(i + 1)}
                      disabled={currentProfilePage === i + 1}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button className="pagination-btn" onClick={() => setCurrentProfilePage(currentProfilePage + 1)} disabled={currentProfilePage === totalProfilePages}>Próxima</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      
      <div id="grupos" className="section-container">
        <div className="main-header user-header-flex">
          <div className="usuarios-title-group">
            <h2 className="usuarios-title">Grupos</h2>
            <div className="user-filter-group">
              <TableFilter filters={[{
                label: 'Perfil',
                value: 'group-profile-filter',
                selected: profileGroupFilter,
                onChange: (val) => { setProfileGroupFilter(val); setCurrentGroupPage(1); },
                options: profileOptions
              }]} />
              <TableSearch
                value={groupSearchTerm}
                onChange={val => { setGroupSearchTerm(val); setCurrentGroupPage(1); }}
                placeholder="Buscar por nome do grupo..."
              />
            </div>
          </div>
          <button onClick={onAddGroup} className="add-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            <span>Novo Grupo</span>
          </button>
        </div>
        <div className="content-area">
          {loading ? <p className="loading-text">Carregando...</p> : (
            <>
              <table>
                <thead>
                  <tr>
                    <th>Nome do Grupo</th>
                    <th>Perfil Associado</th>
                    <th>URL Padrão</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedGrupos.length > 0 ? paginatedGrupos.map(g => (
                    <tr key={g.id}>
                      <td data-label="Nome do Grupo">{g.nome_grupo}</td>
                      <td data-label="Perfil Associado">{profiles.find(p => p.id === g.profile_id)?.["profile name"] || 'Nenhum'}</td>
                      <td data-label="URL Padrão">{g.default_url || '-'}</td>
                      <td data-label="Ações" className="actions-cell">
                        <button onClick={() => onEditGroup(g)} className="action-button edit">Editar</button>
                        <button onClick={() => onDeleteGroup(g)} className="action-button delete">Excluir</button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="4" className="empty-table-message">Nenhum grupo cadastrado.</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* Paginação de grupos */}
              {totalGroupPages > 1 && (
                <div className="pagination-container">
                  <button className="pagination-btn" onClick={() => setCurrentGroupPage(currentGroupPage - 1)} disabled={currentGroupPage === 1}>Anterior</button>
                  {Array.from({ length: totalGroupPages }, (_, i) => (
                    <button
                      key={i + 1}
                      className={`pagination-btn${currentGroupPage === i + 1 ? ' active' : ''}`}
                      onClick={() => setCurrentGroupPage(i + 1)}
                      disabled={currentGroupPage === i + 1}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button className="pagination-btn" onClick={() => setCurrentGroupPage(currentGroupPage + 1)} disabled={currentGroupPage === totalGroupPages}>Próxima</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      
      <div id="usuarios" className="section-container">
        <div className="main-header user-header-flex">
          <div className="usuarios-title-group">
            <h2 className="usuarios-title">Usuários</h2>
            <div className="user-filter-group">
              <TableFilter filters={filterProps} />
              <TableSearch
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Buscar por nome..."
              />
            </div>
          </div>
          <button onClick={onAddUser} className="add-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            <span>Novo Usuário</span>
          </button>
        </div>
        <div className="content-area">
          {loading ? <p className="loading-text">Carregando...</p> : (
            <>
              <table>
                <thead><tr><th>Nome Completo</th><th>Email</th><th>Grupo</th><th>Status</th><th>Ações</th></tr></thead>
                <tbody>
                  {paginatedUsers.length > 0 ? paginatedUsers.map(usuario => (
                    <tr key={usuario.id}>
                      <td data-label="Nome Completo">{usuario.nome_completo || 'Não definido'}</td>
                      <td data-label="Email">{usuario.email}</td>
                      <td data-label="Grupo">{usuario.nome_grupo}</td>
                      <td data-label="Status">
                        <span className={`status-badge status-${usuario.status || 'inativo'}`}>{usuario.status || 'inativo'}</span>
                      </td>
                      <td data-label="Ações" className="actions-cell">
                        <button onClick={() => onEditUser(usuario)} className="action-button edit">Editar</button>
                        <button onClick={() => onToggleStatus(usuario)} disabled={loading} className={`action-button status-toggle-${usuario.status || 'inativo'}`}>{usuario.status === 'ativo' ? 'Desativar' : 'Ativar'}</button>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="5" className="empty-table-message">Nenhum usuário cadastrado.</td></tr>
                  )}
                </tbody>
              </table>
              {/* Paginação */}
              {totalPages > 1 && (
                <div className="pagination-container">
                  <button className="pagination-btn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Anterior</button>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      key={i + 1}
                      className={`pagination-btn${currentPage === i + 1 ? ' active' : ''}`}
                      onClick={() => handlePageChange(i + 1)}
                      disabled={currentPage === i + 1}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button className="pagination-btn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Próxima</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

// Componente principal do Dashboard
function Dashboard({ session }) {
  const [profiles, setProfiles] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [proxies, setProxies] = useState([]); // <-- novo estado
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [isGroupModalOpen, setGroupModalOpen] = useState(false);
  const [isUserModalOpen, setUserModalOpen] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const [editingGroup, setEditingGroup] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [activePage, setActivePage] = useState('gerenciar');
  const [confirmModalState, setConfirmModalState] = useState({ isOpen: false, title: '', message: '', onConfirm: () => {} });

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const [profilesRes, gruposRes, usersRes, linksRes, proxiesRes] = await Promise.all([
        supabase.from('profiles').select('id, "profile name"'),
        supabase.from('grupos').select('id, nome_grupo, profile_id, proxies_id, default_url'),
        supabase.rpc('get_all_users'),
        supabase.from('usuarios_grupos').select('user_id, grupo_id'),
        supabase.from('proxie').select('id, host, port') // <-- busca proxies
      ]);
      if (profilesRes.error) throw profilesRes.error;
      if (gruposRes.error) throw gruposRes.error;
      if (usersRes.error) throw usersRes.error;
      if (linksRes.error) throw linksRes.error;
      const profilesData = profilesRes.data || [];
      const gruposData = gruposRes.data || [];
      const usersData = usersRes.data || [];
      const userGroupLinks = linksRes.data || [];
      setProfiles(profilesData);
      setGrupos(gruposData);
      setProxies(proxiesRes.data || []); // <-- salva proxies
      const combinedUsers = usersData.map(usuario => {
        const link = userGroupLinks.find(link => link.user_id === usuario.id);
        const grupo = link ? gruposData.find(g => g.id === link.grupo_id) : null;
        return { ...usuario, nome_grupo: grupo ? grupo.nome_grupo : 'Sem grupo', grupo_id: grupo ? grupo.id : null };
      });
      setUsuarios(combinedUsers);
    } catch (fetchError) {
      console.error("Erro ao buscar dados:", fetchError);
      setError(`Falha ao carregar dados: ${fetchError.message}`);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line
  useEffect(() => { fetchData(); }, []);

  const handleLogout = async () => { await supabase.auth.signOut(); };

  const toggleUserStatus = async (usuario) => {
    if (loading) return;
    setLoading(true);
    const newStatus = usuario.status === 'ativo' ? 'inativo' : 'ativo';
    const { error: rpcError } = await supabase.rpc('update_user_status', { user_id_to_update: usuario.id, new_status: newStatus });
    if (rpcError) { alert('Erro ao atualizar status: ' + rpcError.message); }
    await fetchData();
    setLoading(false);
  };

  const handleDeleteRequest = (title, message, confirmAction) => {
    setConfirmModalState({ isOpen: true, title, message, onConfirm: confirmAction });
  };

  const closeConfirmModal = () => {
    setConfirmModalState({ isOpen: false, title: '', message: '', onConfirm: () => {} });
  };

  const performDeleteProfile = async (profileId) => {
    setLoading(true);
    const { error } = await supabase.from('profiles').delete().eq('id', profileId);
    if (error) { alert("Erro ao excluir perfil: " + error.message); }
    closeConfirmModal();
    await fetchData();
    setLoading(false);
  };

  const performDeleteGroup = async (groupId) => {
    setLoading(true);
    const { error } = await supabase.from('grupos').delete().eq('id', groupId);
    if (error) { alert("Erro ao excluir grupo: " + error.message); }
    closeConfirmModal();
    await fetchData();
    setLoading(false);
  };

  const renderActivePage = () => {
    switch (activePage) {
      case 'gerenciar':
        return <ManagementView 
                  loading={loading} profiles={profiles} grupos={grupos} usuarios={usuarios} 
                  onAddProfile={() => setProfileModalOpen(true)} onAddGroup={() => setGroupModalOpen(true)} onAddUser={() => setUserModalOpen(true)} 
                  onToggleStatus={toggleUserStatus}
                  onEditProfile={(profile) => setEditingProfile(profile)} onEditGroup={(group) => setEditingGroup(group)} onEditUser={(user) => setEditingUser(user)}
                  onDeleteProfile={(profile) => handleDeleteRequest('Excluir Perfil', `Tem certeza que deseja excluir o perfil "${profile["profile name"]}"?`, () => performDeleteProfile(profile.id))}
                  onDeleteGroup={(group) => handleDeleteRequest('Excluir Grupo', `Tem certeza que deseja excluir o grupo "${group.nome_grupo}"?`, () => performDeleteGroup(group.id))}
               />;
      case 'proxy':
        return <Proxy />;
      case 'allowedUrls':
        return <AllowedUrls />;
      case 'config':
        return <Settings />;
      default:
        return <div>Página não encontrada</div>;
    }
  };

  const getPageTitle = () => {
    switch (activePage) {
      case 'gerenciar': return 'Gerenciamento';
      case 'proxy': return 'Proxies';
      case 'allowedUrls': return 'URLs Permitidas';
      case 'config': return 'Configurações';
      default: return 'Gerenciamento';
    }
  };

  return (
    <div className="app-layout">
      {isProfileModalOpen && <AddProfileModal closeModal={() => setProfileModalOpen(false)} onDataAdded={fetchData} />}
      {isGroupModalOpen && <AddGroupModal profiles={profiles} proxies={proxies} closeModal={() => setGroupModalOpen(false)} onDataAdded={fetchData} />}
      {isUserModalOpen && <AddUserModal grupos={grupos} closeModal={() => setUserModalOpen(false)} onDataAdded={fetchData} />}
      {editingProfile && <EditProfileModal profile={editingProfile} closeModal={() => setEditingProfile(null)} onDataEdited={fetchData} />}
      {editingGroup && <EditGroupModal group={editingGroup} profiles={profiles} proxies={proxies} closeModal={() => setEditingGroup(null)} onDataEdited={fetchData} />}
      {editingUser && <EditUserModal user={editingUser} grupos={grupos} closeModal={() => setEditingUser(null)} onDataEdited={fetchData} />}
      {confirmModalState.isOpen && (<ConfirmModal title={confirmModalState.title} message={confirmModalState.message} onConfirm={confirmModalState.onConfirm} onCancel={closeConfirmModal} confirmText="Sim, Excluir" />)}
      
      <Sidebar userEmail={session.user.email} onLogout={handleLogout} isOpen={isSidebarOpen} toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} activePage={activePage} onNavigate={(page) => { setActivePage(page); setSidebarOpen(false); }} />
      {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}

      <main className="main-content">
        <header className="main-content-header">
          <button className="hamburger-btn" onClick={() => setSidebarOpen(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          </button>
          <h1>{getPageTitle()}</h1>
        </header>
        {error && <p className="error-message main-error">{error}</p>}
        {renderActivePage()}
      </main>
    </div>
  );
}

export default Dashboard;